module.exports = __webpack_public_path__ + "static/media/afshin.edf5e5ee.jpg";